import moment from 'moment'
import * as R from 'ramda'
import React, { useState } from 'react'

import { useExperimentMetrics } from 'hooks/useExperimentMetrics.hook'

import MethodSelection from './MethodSelection'
import WinnerSelection from './WinnerSelection'

import './style.css'

const EndExperimentModal = ({ publishedPlaybook, ...rest }) => {
  const [currentStep, setCurrentStep] = useState(0)

  const handleNextStepClick = () => setCurrentStep(R.inc)
  const handlePreviousStepClick = () => setCurrentStep(R.dec)

  const { data: experimentResults, isLoading } = useExperimentMetrics(
    publishedPlaybook.id,
    publishedPlaybook.updatedAt
  )

  const StepComponent = [MethodSelection, WinnerSelection][currentStep]

  const timeSinceLastPublish = moment
    .duration(moment().diff(publishedPlaybook.updatedAt))
    .humanize()

  return (
    <StepComponent
      isLoading={isLoading}
      experimentResults={experimentResults}
      timeSinceLastPublish={timeSinceLastPublish}
      onNextStepClick={handleNextStepClick}
      onPreviousStepClick={handlePreviousStepClick}
      {...rest}
    />
  )
}

export default EndExperimentModal
